import React from 'react';

import { makeStyles } from 'tss-react/mui';
import {Checkbox, Chip} from 'web-library';
import { KeyValueResponse } from '../../../../api';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';

const useStyles = makeStyles()((theme) =>
({
  menuItemsContainer: {
    width: '65%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  rootContainer: {
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(6),
    padding: '0 !important',
  },
}));

interface IRegistrationExamLevel {
  isSubject?: boolean;
  label: string;
  data:  KeyValueResponse[];
  onSetValue: (title: string, value: any) => void;
  onSetExamValue?: (value: any) => void;
  onSetIsDisable?: (_isDisable: boolean) => void;
  control: any;
  isError: boolean;
  errorMsg?: string;
  valueTitle: string;
  placeholder: string;
  loading?: boolean;
}

const renderTags = (tagValue: any, getTagProps: any) =>
  tagValue.map((option: { description: string }, tagIndex: any) => (
    <Chip
      id="auto-complete-subject"
      label={option.description}
      {...getTagProps({ index: tagIndex })}
    />
  ));

const RegistrationExamLevel = ({
  isSubject = false,
  label,
  data,
  onSetExamValue,
  onSetIsDisable,
  onSetValue,
  control,
  isError,
  errorMsg,
  valueTitle,
  placeholder,
  loading = false,
}: IRegistrationExamLevel) => {
  const { classes } = useStyles();

  return (
    <ControlledAutocomplete<KeyValueResponse, true, false, undefined>
      loading={loading}
      isRequired
      id="inputSelect"
      name={valueTitle}
      control={control}
      label={label}
      options={data}
      className={classes.menuItemsContainer}
      classes={{
        root: classes.rootContainer,
      }}
      placeholder={placeholder}
      error={isError}
      helperText={errorMsg}
      multiple
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
      isOptionEqualToValue={(option: KeyValueResponse, value: KeyValueResponse) =>
        option.code === value.code
      }
      renderOption={(_, option, state, __) => (
        <>
          <Checkbox checked={state.selected}/>
          {option.description}
        </>
      )}
      renderTags={renderTags}
      disableCloseOnSelect
      onChange={(event: any, value: any) => {
        if (onSetIsDisable) {
          onSetIsDisable(!value.length);
        }
        if (onSetExamValue) {
          onSetExamValue(value);
        }
        onSetValue(valueTitle, value || []);
      }}
      defaultValue={[]}
    />
  );
};

export default RegistrationExamLevel;
